package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class PomodoroSessionQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    date_start: String,
    date_end: String?,
    status: String,
    timer_minutes: Long,
    started_at: Long,
    ended_at: Long?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-698_708_746, arrayOf("pomodoro_session"), driver, "PomodoroSession.sq",
      "selectAll",
      "SELECT pomodoro_session.id, pomodoro_session.date_start, pomodoro_session.date_end, pomodoro_session.status, pomodoro_session.timer_minutes, pomodoro_session.started_at, pomodoro_session.ended_at, pomodoro_session.created_at, pomodoro_session.updated_at, pomodoro_session.is_deleted, pomodoro_session.deleted_at, pomodoro_session.synced_at FROM pomodoro_session WHERE is_deleted = 0 ORDER BY date_start DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectAll(): Query<Pomodoro_session> = selectAll { id, date_start, date_end, status,
      timer_minutes, started_at, ended_at, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Pomodoro_session(
      id,
      date_start,
      date_end,
      status,
      timer_minutes,
      started_at,
      ended_at,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    date_start: String,
    date_end: String?,
    status: String,
    timer_minutes: Long,
    started_at: Long,
    ended_at: Long?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectById(id: String): Query<Pomodoro_session> = selectById(id) { id_, date_start,
      date_end, status, timer_minutes, started_at, ended_at, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Pomodoro_session(
      id_,
      date_start,
      date_end,
      status,
      timer_minutes,
      started_at,
      ended_at,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectExtendedCovering(
    date_start: String,
    date_end: String?,
    mapper: (
      id: String,
      date_start: String,
      date_end: String?,
      status: String,
      timer_minutes: Long,
      started_at: Long,
      ended_at: Long?,
      created_at: Long,
      updated_at: Long,
      is_deleted: Long,
      deleted_at: Long?,
      synced_at: Long?,
    ) -> T,
  ): Query<T> = SelectExtendedCoveringQuery(date_start, date_end) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectExtendedCovering(date_start: String, date_end: String?): Query<Pomodoro_session>
      = selectExtendedCovering(date_start, date_end) { id, date_start_, date_end_, status,
      timer_minutes, started_at, ended_at, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Pomodoro_session(
      id,
      date_start_,
      date_end_,
      status,
      timer_minutes,
      started_at,
      ended_at,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByDate(date_start: String, mapper: (
    id: String,
    date_start: String,
    date_end: String?,
    status: String,
    timer_minutes: Long,
    started_at: Long,
    ended_at: Long?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByDateQuery(date_start) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectByDate(date_start: String): Query<Pomodoro_session> = selectByDate(date_start) {
      id, date_start_, date_end, status, timer_minutes, started_at, ended_at, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Pomodoro_session(
      id,
      date_start_,
      date_end,
      status,
      timer_minutes,
      started_at,
      ended_at,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectHistory(
    date_start: String,
    `value`: Long,
    mapper: (
      id: String,
      date_start: String,
      date_end: String?,
      status: String,
      timer_minutes: Long,
      started_at: Long,
      ended_at: Long?,
      created_at: Long,
      updated_at: Long,
      is_deleted: Long,
      deleted_at: Long?,
      synced_at: Long?,
    ) -> T,
  ): Query<T> = SelectHistoryQuery(date_start, value) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectHistory(date_start: String, value_: Long): Query<Pomodoro_session> =
      selectHistory(date_start, value_) { id, date_start_, date_end, status, timer_minutes,
      started_at, ended_at, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Pomodoro_session(
      id,
      date_start_,
      date_end,
      status,
      timer_minutes,
      started_at,
      ended_at,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    date_start: String,
    date_end: String?,
    status: String,
    timer_minutes: Long,
    started_at: Long,
    ended_at: Long?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_441_516_057, arrayOf("pomodoro_session"), driver,
      "PomodoroSession.sq", "selectDirty",
      "SELECT pomodoro_session.id, pomodoro_session.date_start, pomodoro_session.date_end, pomodoro_session.status, pomodoro_session.timer_minutes, pomodoro_session.started_at, pomodoro_session.ended_at, pomodoro_session.created_at, pomodoro_session.updated_at, pomodoro_session.is_deleted, pomodoro_session.deleted_at, pomodoro_session.synced_at FROM pomodoro_session WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectDirty(): Query<Pomodoro_session> = selectDirty { id, date_start, date_end,
      status, timer_minutes, started_at, ended_at, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Pomodoro_session(
      id,
      date_start,
      date_end,
      status,
      timer_minutes,
      started_at,
      ended_at,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    date_start: String,
    date_end: String?,
    status: String,
    timer_minutes: Long,
    started_at: Long,
    ended_at: Long?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Pomodoro_session> = selectByIdAnyState(id) { id_,
      date_start, date_end, status, timer_minutes, started_at, ended_at, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Pomodoro_session(
      id_,
      date_start,
      date_end,
      status,
      timer_minutes,
      started_at,
      ended_at,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    date_start: String,
    date_end: String?,
    status: String,
    timer_minutes: Long,
    started_at: Long,
    ended_at: Long?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-1_451_770_264, """
        |INSERT INTO pomodoro_session(
        |    id, date_start, date_end, status, timer_minutes, started_at, ended_at, created_at, updated_at
        |) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 9) {
          bindString(0, id)
          bindString(1, date_start)
          bindString(2, date_end)
          bindString(3, status)
          bindLong(4, timer_minutes)
          bindLong(5, started_at)
          bindLong(6, ended_at)
          bindLong(7, created_at)
          bindLong(8, updated_at)
        }
    notifyQueries(-1_451_770_264) { emit ->
      emit("pomodoro_session")
    }
  }

  public fun updateStatus(
    status: String,
    ended_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(15_644_298,
        """UPDATE pomodoro_session SET status = ?, ended_at = ?, updated_at = ? WHERE id = ?""", 4)
        {
          bindString(0, status)
          bindLong(1, ended_at)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(15_644_298) { emit ->
      emit("pomodoro_session")
    }
  }

  public fun updateTimerMinutes(
    timer_minutes: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_436_056_178,
        """UPDATE pomodoro_session SET timer_minutes = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, timer_minutes)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_436_056_178) { emit ->
      emit("pomodoro_session")
    }
  }

  public fun updateDateEnd(
    date_end: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-469_580_107,
        """UPDATE pomodoro_session SET date_end = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, date_end)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-469_580_107) { emit ->
      emit("pomodoro_session")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(875_801_252,
        """UPDATE pomodoro_session SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(875_801_252) { emit ->
      emit("pomodoro_session")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(2_078_694_870,
        """UPDATE pomodoro_session SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(2_078_694_870) { emit ->
      emit("pomodoro_session")
    }
  }

  public fun update(
    date_start: String,
    date_end: String?,
    status: String,
    timer_minutes: Long,
    started_at: Long,
    ended_at: Long?,
    created_at: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_106_824_072, """
        |UPDATE pomodoro_session
        |SET date_start = ?, date_end = ?, status = ?, timer_minutes = ?, started_at = ?, ended_at = ?, created_at = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 9) {
          bindString(0, date_start)
          bindString(1, date_end)
          bindString(2, status)
          bindLong(3, timer_minutes)
          bindLong(4, started_at)
          bindLong(5, ended_at)
          bindLong(6, created_at)
          bindLong(7, updated_at)
          bindString(8, id)
        }
    notifyQueries(-1_106_824_072) { emit ->
      emit("pomodoro_session")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_380_142_271,
        """UPDATE pomodoro_session SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_380_142_271) { emit ->
      emit("pomodoro_session")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_session", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_session", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-185_093_347,
        """SELECT pomodoro_session.id, pomodoro_session.date_start, pomodoro_session.date_end, pomodoro_session.status, pomodoro_session.timer_minutes, pomodoro_session.started_at, pomodoro_session.ended_at, pomodoro_session.created_at, pomodoro_session.updated_at, pomodoro_session.is_deleted, pomodoro_session.deleted_at, pomodoro_session.synced_at FROM pomodoro_session WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "PomodoroSession.sq:selectById"
  }

  private inner class SelectExtendedCoveringQuery<out T : Any>(
    public val date_start: String,
    public val date_end: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_session", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_session", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_195_648_017, """
    |SELECT pomodoro_session.id, pomodoro_session.date_start, pomodoro_session.date_end, pomodoro_session.status, pomodoro_session.timer_minutes, pomodoro_session.started_at, pomodoro_session.ended_at, pomodoro_session.created_at, pomodoro_session.updated_at, pomodoro_session.is_deleted, pomodoro_session.deleted_at, pomodoro_session.synced_at FROM pomodoro_session
    |WHERE is_deleted = 0
    |  AND date_start <= ?
    |  AND date_end   >= ?
    |ORDER BY date_start DESC
    |LIMIT 1
    """.trimMargin(), mapper, 2) {
      bindString(0, date_start)
      bindString(1, date_end)
    }

    override fun toString(): String = "PomodoroSession.sq:selectExtendedCovering"
  }

  private inner class SelectByDateQuery<out T : Any>(
    public val date_start: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_session", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_session", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_781_195_472, """
    |SELECT pomodoro_session.id, pomodoro_session.date_start, pomodoro_session.date_end, pomodoro_session.status, pomodoro_session.timer_minutes, pomodoro_session.started_at, pomodoro_session.ended_at, pomodoro_session.created_at, pomodoro_session.updated_at, pomodoro_session.is_deleted, pomodoro_session.deleted_at, pomodoro_session.synced_at FROM pomodoro_session
    |WHERE is_deleted = 0 AND date_start = ?
    |LIMIT 1
    """.trimMargin(), mapper, 1) {
      bindString(0, date_start)
    }

    override fun toString(): String = "PomodoroSession.sq:selectByDate"
  }

  private inner class SelectHistoryQuery<out T : Any>(
    public val date_start: String,
    public val `value`: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_session", "pomodoro_item", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_session", "pomodoro_item", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_233_470_825, """
    |SELECT pomodoro_session.id, pomodoro_session.date_start, pomodoro_session.date_end, pomodoro_session.status, pomodoro_session.timer_minutes, pomodoro_session.started_at, pomodoro_session.ended_at, pomodoro_session.created_at, pomodoro_session.updated_at, pomodoro_session.is_deleted, pomodoro_session.deleted_at, pomodoro_session.synced_at FROM pomodoro_session
    |WHERE is_deleted = 0
    |  AND date_start < ?
    |  AND id IN (SELECT session_id FROM pomodoro_item WHERE is_deleted = 0)
    |ORDER BY date_start DESC
    |LIMIT ?
    """.trimMargin(), mapper, 2) {
      bindString(0, date_start)
      bindLong(1, value)
    }

    override fun toString(): String = "PomodoroSession.sq:selectHistory"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("pomodoro_session", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("pomodoro_session", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_582_213_054,
        """SELECT pomodoro_session.id, pomodoro_session.date_start, pomodoro_session.date_end, pomodoro_session.status, pomodoro_session.timer_minutes, pomodoro_session.started_at, pomodoro_session.ended_at, pomodoro_session.created_at, pomodoro_session.updated_at, pomodoro_session.is_deleted, pomodoro_session.deleted_at, pomodoro_session.synced_at FROM pomodoro_session WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "PomodoroSession.sq:selectByIdAnyState"
  }
}
